// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"37ae0af2","72":"d3330773","477":"7d70a09a","627":"4392f2b1","663":"3cbcda7a","667":"d62a5199","777":"c789e99c","803":"09f43558","820":"6e6f312a"}[chunkId] + ".chunk.js";
};